import styled from "styled-components";

export const SuccessAlert = styled.div(props => ({
    padding: '8px 1rem',
    margin: '2rem 0 1rem',
    borderRadius: '15px',
    border: `solid 1px ${props.theme.palette.green['600']}`,
    backgroundColor: props.theme.palette.green["400"]
}));

export const ErrorAlert = styled(SuccessAlert)(props => ({
    border: `solid 1px ${props.theme.palette.primary["500"]}`,
    backgroundColor: props.theme.palette.primary["100"],
    color: props.theme.palette.primary.mainHover
}));

export const InfoAlert = styled(SuccessAlert)(props => ({
    border: `solid 1px ${props.theme.palette.blue["500"]}`,
    backgroundColor: props.theme.palette.blue.notifications,
    color: '#000'
}));
